import { useEffect } from "react";
import { useReactiveVar } from "@apollo/client";
import { newOrder } from "../../apollo";
import { NewOrderLists } from "../../hooks/subNewOrderList";
import refresh from "../../assets/icon/refresh.png";
import searchdate from "../../assets/icon/searchdate.png";
import { IDateSearchFormProps } from "./component-tab-order";
import { useForm } from "react-hook-form";
import React from "react";

export interface ComponentTabAll {
  dataList?: any[];
  refetch?(): void;
  setDateSearch?: (sDate?: Date, eDate?: Date) => void;
}

// 배송관리 - "전체" 탭 헤더: 상태 구분 없이 전체 주문내역을 대상으로 새로고침/기간검색만 제공한다.
// 26년 5월 이전 데이터는 페이지(admin-list-order-all.tsx)에서 항상 하한선으로 걸러진다.
export const ComponentTabAll: React.FC<ComponentTabAll> = ({
  setDateSearch,
}) => {
  const { register, getValues, handleSubmit } = useForm<IDateSearchFormProps>({
    mode: "all",
  });

  const refetchHandler = () => {
    window.location.href = "/order-manage";
  };

  const onSubmit = () => {
    const { sDate, eDate } = getValues();
    if (setDateSearch) {
      setDateSearch(sDate, eDate);
    }
  };

  // 다른 배송관리 탭(주문확인/주문내역 등)과 동일하게, 새 주문이 들어오면
  // 새로고침 버튼 위에 빨간 점을 깜빡이며 표시한다. 사이드바 "주문 관리" 배지와 같은 신호(newOrder)를 공유한다.
  const IsNewOrder = useReactiveVar(newOrder);
  const { data: newOrderList } = NewOrderLists();

  useEffect(() => {
    if (newOrderList && newOrderList.newOrderList.length > 0) {
      newOrder(true);
    }
  }, [newOrderList]);

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex flex-wrap">
        <button
          className="py-3 px-4 relative"
          onClick={() => {
            refetchHandler();
            newOrder(false);
          }}
        >
          {IsNewOrder && (
            <div className="absolute right-2 top-2 w-3 h-3 block rounded-full bg-red-400">
              <span className="w-full h-full block rounded-full animate-ping bg-red-400"></span>
            </div>
          )}
          <img src={refresh} alt="새로고침" className="w-[30px] h-[30px]" />
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap gap-x-4 content-center">
          <p className="text-[#8B8C8C] text-sm flex flex-wrap content-center">
            기간
          </p>
          <div className="flex flex-wrap content-center">
            <input
              {...register("sDate")}
              type="date"
              min="2026-05-01"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>
          <span className="text-white flex flex-wrap content-center">~</span>
          <div className="flex flex-wrap content-center">
            <input
              {...register("eDate")}
              type="date"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>

          <button className="py-3">
            <img src={searchdate} alt="찾기" className="w-[32px] h-[30px]" />
          </button>
        </div>
      </form>
      <div className="w-[104px]"></div>
    </div>
  );
};
